import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
var _window = /*#__PURE__*/_classPrivateFieldLooseKey("window");
export class WebSender {
  constructor(customWindow) {
    Object.defineProperty(this, _window, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _window)[_window] = customWindow || globalThis.parent;
  }
  send(event) {
    if (typeof window === 'undefined') {
      return;
    }
    try {
      if (typeof window.parent === 'undefined' || typeof window.parent.postMessage !== 'function') {
        throw new Error();
      }
      const {
        type,
        detail
      } = event;

      // TODO Here we send to any domain with *
      // would be safer to provide the domaine to restrict the scope
      _classPrivateFieldLooseBase(this, _window)[_window].postMessage({
        type,
        detail
      }, '*');
    } catch (_unused) {
      throw new Error('Could not send event to host application');
    }
  }
}
//# sourceMappingURL=WebSender.js.map